import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography, TextField, FormControl, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createColor, updateColor, fetchColors } from '../../redux/actions/color/colorAction';
import { toast } from 'react-toastify';

const ColorForm = ({ selectedColor, onReset }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    if (selectedColor) {
      setFormData(selectedColor);
    } else {
      setFormData({ name: '' });
    }
  }, [selectedColor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedColor) {
        await dispatch(updateColor(selectedColor.id, formData));
        toast.success('Color updated successfully');
      } else {
        await dispatch(createColor(formData));
        toast.success('Color created successfully');
      }
      dispatch(fetchColors());
      setFormData({ name: '' });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing color';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({ name: '' });
    if (onReset) onReset();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, boxShadow: 'none', background: 'transparent' }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
        {selectedColor ? 'Edit Color' : 'Add Color'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal" required>
          <TextField
            name="name"
            value={formData.name}
            label="Color"
            onChange={handleChange}
            fullWidth
          />
        </FormControl>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedColor ? 'Update' : 'Add'}
          </Button>
          <Button 
            type="button" 
            variant="outlined" 
            color="primary" 
            fullWidth
            onClick={handleClear}
          >
            Clear
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default ColorForm;
